import Immutable from 'immutable';
import moment from 'moment';
import { TimelineConfig } from '../records';

export default (state = Immutable.Map(), action) => {
  switch (action.type) {
    case 'HYDRATE_TIMELINE_CONFIG':
      return new TimelineConfig(action.payload);
    case 'REPORT_CONFIG_CHANGED':
      return state.set('updatedAt', moment().unix());
    default:
      return state;
  }
};
